// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__WBx98","footer":"Form_footer__1YnqW"};